import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _d7eb0da0 = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _13a46da8 = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _3a5fd7cb = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _23ac4cf3 = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _43098993 = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _11adb8fa = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _58917dfe = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _052efd9c = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _58917025 = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _2b187b46 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _0eb6c8cc = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _20273e36 = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _70f337bc = () => interopDefault(import('../pages/sale/index.vue' /* webpackChunkName: "pages/sale/index" */))
const _776ee513 = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _6ff4354b = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _52b71b76 = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _4f654646 = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _328cc9d3 = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _1c979fb0 = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _1a1100f0 = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _2177dd7d = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _aafa2482 = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _265da333 = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _f97f514c = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _27349cc0 = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _0326dd85 = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _379df807 = () => interopDefault(import('../pages/sale/output.vue' /* webpackChunkName: "pages/sale/output" */))
const _17d90b5b = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _6f485a0e = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _58755f0f = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _1ce35574 = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _f40aa3f2 = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _9dde473c = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _ec3a2fcc = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _cf17b348 = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _daa29ff0 = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _2647daa3 = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _fbfb660a = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _1dacc363 = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _78af23a6 = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _734658ad = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _6cdfbf79 = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _72aeb3b4 = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _4958f7c7 = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _4b7fdb0a = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _393f95d4 = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _f2602680 = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _524377da = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _722e113c = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _51777c5c = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _1e8335d9 = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _6c370b21 = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _1e8da01e = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _1ededd10 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _30700443 = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _3dba16b0 = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _3d85e7fb = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _22429484 = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _35597361 = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _365dfccc = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _5e3cd6a0 = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _454faefa = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _2ae2e16c = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _31602902 = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _7e4229cb = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _bd75f0d0 = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _a1f15e1a = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _578d7422 = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _2882d4bb = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _319737cd = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _380e86fc = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _441a57a8 = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _2e29b580 = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _4dfa5eee = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _f1b99f6c = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _71bb561e = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _d7eb0da0,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _13a46da8,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _3a5fd7cb,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _23ac4cf3,
    name: "calendar"
  }, {
    path: "/customer",
    component: _43098993,
    name: "customer"
  }, {
    path: "/details",
    component: _11adb8fa,
    name: "details"
  }, {
    path: "/goals",
    component: _58917dfe,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _052efd9c,
    name: "maisoku"
  }, {
    path: "/media",
    component: _58917025,
    name: "media"
  }, {
    path: "/privacy",
    component: _2b187b46,
    name: "privacy"
  }, {
    path: "/project",
    component: _0eb6c8cc,
    name: "project"
  }, {
    path: "/response",
    component: _20273e36,
    name: "response"
  }, {
    path: "/sale",
    component: _70f337bc,
    name: "sale"
  }, {
    path: "/achievement/output",
    component: _776ee513,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _6ff4354b,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _52b71b76,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _4f654646,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _328cc9d3,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _1c979fb0,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _1a1100f0,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _2177dd7d,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _aafa2482,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _265da333,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _f97f514c,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _27349cc0,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _0326dd85,
    name: "response-registration"
  }, {
    path: "/sale/output",
    component: _379df807,
    name: "sale-output"
  }, {
    path: "/setting/announcement",
    component: _17d90b5b,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _6f485a0e,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _58755f0f,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _1ce35574,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _f40aa3f2,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _9dde473c,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _ec3a2fcc,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _cf17b348,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _daa29ff0,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _2647daa3,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _fbfb660a,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _1dacc363,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _78af23a6,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _734658ad,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _6cdfbf79,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _72aeb3b4,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _4958f7c7,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _4b7fdb0a,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _393f95d4,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _f2602680,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _524377da,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _722e113c,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _51777c5c,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _1e8335d9,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _6c370b21,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _1e8da01e,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _1ededd10,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _30700443,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _3dba16b0,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _3d85e7fb,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _22429484,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _35597361,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _365dfccc,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _5e3cd6a0,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _454faefa,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _2ae2e16c,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _31602902,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _7e4229cb,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _bd75f0d0,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _a1f15e1a,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _578d7422,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _2882d4bb,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _319737cd,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _380e86fc,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _441a57a8,
    name: "property-property",
    children: [{
      path: "contact",
      component: _2e29b580,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _4dfa5eee,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _f1b99f6c,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _71bb561e,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
